/**
 * Apply event listener to run buttonClicked workflow
 * @param {Object} workflow - buttonClicked workflow
 * @param {Object} eventBus - eventBus instance
 */
export default function(workflow, eventBus) {
  if (!workflow.sourceGrid) throw new Error('[simpleWorkflow] - missing "sourceGrid" property')

  eventBus.$on(`simpleWorkflow-btnClicked-${workflow.sourceGrid}`, async (item) => {
    const actions = workflow.actions

    if (!actions) return

    for (let idx in actions) {
      const action = actions[idx]

      switch (action.type) {
        case 'addRowTo':
          await addRowTo(action, item)
          break
        case 'updateClickedItemRow':
          updateClickedItemRow(workflow.sourceGrid, action, item)
          break
      }
    }
  })
}

async function addRowTo(action, item) {
  let row = item;
  const addedRowKey = await $dgAddRow(action.gridId, { _created: true })
  const newRow = Object.assign({}, $dataGrid(action.gridId)[addedRowKey])

  if (action.writeMethods && action.writeMethods.length) {
    for (let writeMethod of action.writeMethods) {
      switch (writeMethod.type) {
        case 'createdRow':
          newRow[writeMethod.targetCell] = item[writeMethod.sourceCell]
          break
        case 'expression':
          try {
            const value = eval(writeMethod.expression)

            newRow[writeMethod.targetCell] = value
          } catch (err) {
            console.error(err)
          }
          break
      }
    }
  }

  $dgSetRow(action.gridId, addedRowKey, newRow)
}

function updateClickedItemRow(sourceGrid, action, item) {
  let row = item;
  const newRow = $dataGrid(sourceGrid)[item.rowKey]

  if (action.writeMethods && action.writeMethods.length) {
    for (let writeMethod of action.writeMethods) {
      try {
        const value = eval(writeMethod.expression)

        newRow[writeMethod.targetCell] = value
      } catch (err) {
        console.error(err)
      }
    }
  }

  $dgSetRow(sourceGrid, item.rowKey, newRow)
}
